/**************************************************
 * Nombre:       Tarjeta_Lead
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Chip, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import FechaContacto from "./SubComponentesTarjetas/FechaContacto";
import {ArrowForwardIos, Message} from '@mui/icons-material'
import {formatoMonedaTabla} from "../../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";


const Tarjeta_Lead = ({click, item}) => {

    return (
        <Grid
            onClick={() => click(item)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderColor: theme.palette.info.main + 40,
                borderRadius: 2,
                p: 1,
                color: theme.palette.info.main,
                cursor: 'pointer',
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 14, fontWeight: 600}}>{item.nombres + ' ' + item.apellidos}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                <Typography sx={{fontSize: 12, fontWeight: 500, color: theme.palette.primary.main, lineHeight: 1.2}}>
                    {item.programa}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 10, fontWeight: 400}}>
                    {formatoMonedaTabla(item.valor ? item.valor : 0)}
                </Typography>
            </Grid>


            <Grid container size={2} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Avatar src={item.img ? item.img : ''} sx={{width: 30, height: 30}}/>
            </Grid>

            <Grid container size={4} sx={{justifyContent: 'flex-start', mt: 1}}>
                <FechaContacto nombre={'Ultimo Contacto'}
                               fecha={item.contactos && item.contactos[item.contactos.length > 1 ? item.contactos.length - 2 : item.contactos.length - 1].fecha}/>
            </Grid>

            <Grid container size={1} sx={{justifyContent: 'flex-start', mt: 1}}>
                <ArrowForwardIos sx={{width: 16, height: 16, fill: theme.palette.info.main + 90}}/>
            </Grid>

            <Grid container size={4} sx={{justifyContent: 'flex-start', mt: 1}}>
                <FechaContacto nombre={'Proximo Contacto'} fecha={item.fechaProximoContacto} proximo={true}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-end'}
                alignItems={'flex-start'}
                size={1}
                sx={{mt: 1}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', pl: 0.6}}>
                    <Typography sx={{fontSize: 12, color: theme.palette.info.main + 90, lineHeight: 1}}>
                        {item.comentarios ? item.comentarios.length : 0}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 1}} sx={{justifyContent: 'flex-end', mt: 0}}>
                    <Message sx={{width: 16, height: 16, fill: theme.palette.info.main + 90}}/>
                </Grid>

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 1}}
                spacing={1}
            >

                {item && item.etiquetas && item.etiquetas.map((item, i) => (
                    <Chip size={'small'} key={i + 'we'} label={item}
                          sx={{
                              fontSize: 12,
                              fontWeight: 500,
                              backgroundColor: theme.palette.primary.main + 80,
                              color: '#fff'
                          }}/>
                ))}

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Lead

